<template>
    <!--topbar items-->
    <div class="content-wrapper-topbaritems">
        <div class="container">
            <div class="row" :class="topbarItems.length < 3 ? 'row-centered' : ''">
                <template v-for="item in topbarItems" :key="item.Id">
                    <div class="item col-md-4 col-sm-4 col-xs-4 item-trigger-button">
                        <div class="item-inner">
                            <div class="icon" :class="((item.Xhtml != null && item.Xhtml.length > 0) || (item.FaqId != null && item.FaqId > 0)) ? 'trigger' : ''" :data-triggerid="((item.Xhtml != null && item.Xhtml.length > 0) || (item.FaqId != null && item.FaqId > 0) ? 'button-' + item.Id : '')">
                                <span class="circle">
                                    <i :class="item.IconClass" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="text">
                                <h4>
                                    <button v-if="item.Xhtml != null && item.Xhtml.length > 0" :id="'button-' + item.Id" class="track-GA4-event" data-ga4_name="pdp_faq_menu" :data-ga4_model_category="item.ga4_cat" :data-ga4_model_name="item.ga4_name" :data-ga4_click_text="item.TitleLocalized" :data-toggle="((item.Xhtml != null && item.Xhtml.length > 0) || (item.FaqId != null && item.FaqId > 0) ? 'modal' : '')" :data-target="'#topBarModal-' + item.Id">
                                        <span class="title">{{item.TitleLocalized}}</span>
                                    </button>
                                    <span v-show="item.Xhtml == null || item.Xhtml.length == 0">{{item.TitleLocalized}}</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div :id="'topBarModal-' + item.Id" class="faq-modal modal fade" role="dialog" aria-modal="true" :aria-labelledby="'header-' + item.Id" v-if="item.Xhtml != null && item.Xhtml.length > 0">
                        <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="close">&times;</button>
                                </div>
                                <div class="modal-body text-left">
                                    <div class="h1" :id="'header-' + item.Id">{{item.TitleLocalized}}</div>
                                    <div class="content" style="padding-bottom: 40px;" v-html="item.XhtmlLocalized"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :id="'topBarModal-' + item.Id" class="faq-modal modal fade" role="dialog" :data-iframe="'/' + culture + '/contact/faq/detail/' + item.FaqId" aria-modal="true" :aria-labelledby="item.Id" v-if="item.FaqId != null && item.FaqId > 0">
                        <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="close">&times;</button>
                                </div>
                                <div class="modal-body">
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'TopbarItems',
        mixins: [generalMixin],
        data: function () {
            return {
                topbarItems: window.topbarItems,
                culture: window.culture
            }
        },
        methods: {
        },
        computed: {
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        }
    }
</script>
